import { render, staticRenderFns } from "./ContactsV2.vue?vue&type=template&id=4dcf5f8f&"
import script from "./ContactsV2.vue?vue&type=script&lang=js&"
export * from "./ContactsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports